module.exports = __webpack_public_path__ + "static/img/product3-5.04c2ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-5.jpg
// module id = 6HP0
// module chunks = 0